import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";

import { Row, Indent } from "@styles/grid";
import TextInput from "@components/inputs/TextInput";
import Checkbox from "@components/inputs/Checkbox";
import { ButtonPrimary, ButtonSecondaryLink } from "@components/Button";
import { Form } from "@styles/form";
import { Span } from "@styles/typography";
import { createPartner } from "@actions/partners.action";
import { partnerValidationSchema } from "@utils/validation";
import slugify from "slugify";

const PartnerAddForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.partners.loading);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      slug: "",
      walmart_button: true,
      amazon_button: true,
      with_ccl_brand: true,
    },
    validationSchema: partnerValidationSchema,
    onSubmit: async ({ name, slug, walmart_button, amazon_button, with_ccl_brand }) => {
      try {
        const newPartner = {
          name,
          slug,
          walmart_button,
          amazon_button,
          with_ccl_brand,
        };

        const savedPartner = await dispatch(createPartner(newPartner));

        if (savedPartner.data) {
          return history.push("/partners");
        }
      } catch (error) {
        throw new Error(error.message);
      }
    },
  });

  useEffect(() => {
    if (formik.values.name) {
      formik.setFieldValue("slug", slugify(formik.values.name, { lower: true }));
    }
  }, [formik.values.name]);

  return (
    <Form onSubmit={formik.handleSubmit}>
      <TextInput
        label="Name"
        labelPosition="left"
        fluid
        placeholder="Partner Name"
        name="name"
        id="name"
        value={formik.values.name}
        onChange={formik.handleChange}
        formik={formik}
      />
      <TextInput
        label="Slug"
        labelPosition="left"
        fluid
        placeholder="Partner Slug"
        name="slug"
        id="slug"
        value={formik.values.slug}
        onChange={formik.handleChange}
        formik={formik}
      />

      <Row margin="1rem 0">
        <Checkbox
          name="walmart_button"
          id="walmart_button"
          value={formik.values.walmart_button}
          checked={formik.values.walmart_button}
          onClick={formik.handleChange}
          formik={formik}
        />
        <Span size={1.8} margin="0 1rem">
          Walmart button display turn on / off
        </Span>
      </Row>

      <Row margin="1rem 0">
        <Checkbox
          name="amazon_button"
          id="amazon_button"
          value={formik.values.amazon_button}
          checked={formik.values.amazon_button}
          onClick={formik.handleChange}
          formik={formik}
        />
        <Span size={1.8} margin="0 1rem">
          Amazon button display turn on / off
        </Span>
      </Row>

      <Row margin="1rem 0">
        <Checkbox
          name="with_ccl_brand"
          id="with_ccl_brand"
          value={formik.values.with_ccl_brand}
          checked={formik.values.with_ccl_brand}
          onClick={formik.handleChange}
          formik={formik}
        />
        <Span size={1.8} margin="0 1rem">
          CCL app logo display on / off{" "}
        </Span>
      </Row>

      <Row margin="3rem 0" justify="flex-end">
        <Indent margin="0 2rem 0">
          <ButtonSecondaryLink outlined uppercase href="/partners">
            Back to partners
          </ButtonSecondaryLink>
        </Indent>
        <ButtonPrimary type="submit" uppercase disabled={loading} onClick={formik.handleSubmit}>
          Create Partner
        </ButtonPrimary>
      </Row>
    </Form>
  );
};

export default PartnerAddForm;
